import React, {useEffect, useState} from "react";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import keycloak from "../../../Keycloak";
import {getEmails} from "../../../utilities/HrAPI";

export default function Emails({candidateId}) {
    const [emailList, setEmailList] = useState([]);
    const [expanded, setExpanded] = useState(false);

    const sortedEmailList = [...emailList].sort((a,b) =>
        new Date(b.date) - new Date(a.date)
    );

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(() => {
        const fetchEmails = async () => {
            if ((keycloak.hasResourceRole("hr_admin") || keycloak.hasResourceRole("client_recruiter")) && candidateId) {
                try {
                    const emailData = await getEmails(candidateId, keycloak.token);
                    if (emailData && !emailData.isEmpty) {
                        setEmailList(emailData);
                    } else {
                        console.log("No email data found.");
                    }
                } catch (error) {
                    console.error("Error fetching emails:", error);
                }
            }
        };

        fetchEmails();
        const interval = setInterval(() => {
            fetchEmails();
        }, 5000);
        return () => clearInterval(interval);
    }, [candidateId]);

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return date.toLocaleString('en-ZA', options).replace(',', '');
    }

    function formatEmailBody(emailBody) {
        // Regular expression to find ISO date strings
        const isoDateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/;
        const parts = emailBody.split(isoDateRegex); // Split the body at the date

        let formattedDate = '';
        const match = emailBody.match(isoDateRegex);
        if (match) {
            formattedDate = formatDate(match[0]); // Format the date
        }

        // Reassemble the message with the formatted date
        const formattedBody = parts.length > 1
            ? parts[0] + formattedDate + parts[1]
            : parts[0];

        return formattedBody.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    }

    return (
        <Box xs={12} data-testid="accordion">
            {sortedEmailList.map((email, index) => (
                <Accordion
                    key={index}
                    className="mb-3"
                    sx={{
                        border: '0 !important', boxShadow: 'none',
                        '.MuiAccordion-root:before': {
                            backgroundColor: 'transparent !important'
                        }
                    }}
                    expanded={expanded.toString() === `panel${index}`}
                    onChange={handleChange(`panel${index}`)}>
                    <AccordionSummary className="p-3 bg-secondary-1 justify-content-between m-0"
                                      sx={{
                                          '.MuiAccordionSummary-content': {
                                              margin: '0'
                                          }
                                      }}
                                      data-testid={`accordionSummary-${index}`}>
                        <Grid item xs={8} justifyContent="space-between" className="m-0">
                            <div className="text-4">
                                <MailOutlineIcon/> {email.subject + (expanded.toString() !== `panel${index}` ? (": " + email.body.substring(0, 60) + "...") : '')}
                            </div>
                        </Grid>
                        <Grid item xs={4} data-testid="sentDate">
                            <div className="text-4">
                                {formatDate(email.date)}
                            </div>
                        </Grid>
                    </AccordionSummary>
                    <AccordionDetails data-testid={`accordionDetails-${index}`} className="bg-secondary-1">
                        <div className="text-4">
                        {formatEmailBody(email.body)}
                        </div>
                    </AccordionDetails>
                </Accordion>
            ))
            }
        </Box>
    )
}